// ToDo: Investigate this. We don't need this locally, but in other env missing this - leeds to error
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
window.practitest = window.practitest || {};
window.pt_ts = window.pt_ts || {};

export const hasPermission = (permission: string) =>
  practitest?.frontend?.ts_utils?.hasPermission(permission) ?? false;

export const getCljsField = (fieldId: string) => {
  return practitest?.frontend?.ts_utils?.getCljsField(fieldId);
};

export const getTranslation = (key: string, defaultText: string) => {
  return practitest?.frontend?.ts_utils?.getTranslation(key, defaultText) ?? "";
};

export const formatTranslation = (
  key: string,
  defaultText: string,
  params: object,
) => {
  return practitest?.frontend?.ts_utils?.formatTranslation(
    key,
    defaultText,
    params,
  );
};

export const showNotification = (type: string, message: string) => {
  return practitest?.frontend?.ts_utils?.showNotification(type, message);
};

export const getEntityName = (entity: string, nameType: string) => {
  return practitest?.frontend?.ts_utils?.getEntityName(entity, nameType);
};

export const debounce = <T extends (...args: any[]) => any>(
  fn: T,
  interval: number,
  opt_scope?: any,
) => {
  return practitest?.frontend?.ts_utils?.debounce(fn, interval, opt_scope);
};
